import { render } from "./QuestionAsker.vue?vue&type=template&id=137be1c9&scoped=true"
import script from "./QuestionAsker.vue?vue&type=script&lang=js"
export * from "./QuestionAsker.vue?vue&type=script&lang=js"

import "./QuestionAsker.vue?vue&type=style&index=0&id=137be1c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137be1c9"]])

export default __exports__